const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var PostFinance24 = function PostFinance24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "#FCD205",
      d: "M2 19.914h56V4.086H2v15.828Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#fff",
      d: "m48.506 16.296.547-2.591H4.391l-.548 2.59h44.663Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#ED1C24",
      d: "M53.885 10.173s.599-2.746.607-2.772h-3.805c0 .018-.787 3.644-.787 3.661h.975c.008 0 .598-2.737.598-2.737h1.848s-.582 2.745-.599 2.763h2.814l-.368 1.693h-2.797c0 .017-.564 2.583-.564 2.583h-2.113c0 .008-.188.923-.196.932h3.113c0-.009.556-2.591.556-2.591h2.797c0-.01.735-3.515.735-3.532h-2.814Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#231F20",
      d: "M46.998 10.986c.402 0 .676.273.676.726 0 .077-.008.146-.017.223h-1.736c.18-.573.564-.95 1.077-.95Zm.864 3.403.223-1.018c-.377.128-.745.231-1.215.231-.547 0-1.026-.188-1.052-.847h2.823c.102-.333.162-.667.162-.974 0-.941-.547-1.711-1.72-1.711-1.521 0-2.445 1.249-2.445 2.626 0 1.18.787 1.873 2.01 1.873.496 0 .889-.077 1.214-.18Zm-4.644-.864c-.556 0-.932-.24-.932-.932 0-.812.513-1.488 1.326-1.488.256 0 .547.077.838.188l.205-.975a3.39 3.39 0 0 0-1.12-.205c-1.343 0-2.49 1-2.49 2.54 0 1.266.78 1.864 1.9 1.864.376 0 .692-.068.923-.162l.223-1a2.471 2.471 0 0 1-.873.17Zm-5.91.915.471-2.163c.188-.873.616-1.172 1.06-1.172.574 0 .642.428.53.915l-.513 2.42h1.224l.538-2.48c.265-1.24-.308-1.89-1.205-1.89-.497 0-.975.197-1.386.633l.111-.504h-1.137l-.915 4.241h1.223Zm-4.395-1.223c0-.427.376-.667 1-.667.12 0 .385.01.625.043l-.052.24c-.145.504-.555.847-1.043.847-.35 0-.53-.172-.53-.463Zm1.18-3.121a5.13 5.13 0 0 0-1.326.188l-.205.983c.273-.076.812-.222 1.292-.222.64 0 .872.197.872.53 0 .06 0 .129-.017.197l-.018.085a8.708 8.708 0 0 0-.735-.06c-1.214 0-2.189.471-2.189 1.583 0 .727.564 1.163 1.3 1.163.521 0 .966-.205 1.257-.547l-.094.444h1.086l.53-2.428c.043-.18.06-.368.06-.548 0-.727-.402-1.368-1.813-1.368Zm-5.927 4.344.47-2.163c.189-.873.616-1.172 1.061-1.172.573 0 .642.428.53.915l-.513 2.42h1.223l.539-2.48c.265-1.24-.308-1.89-1.206-1.89-.496 0-.975.197-1.386.633l.111-.504h-1.137l-.915 4.241h1.223Zm-2.19-5.413a.624.624 0 0 0 .634.684c.419 0 .718-.3.743-.684a.624.624 0 0 0-.632-.684.721.721 0 0 0-.744.684Zm-.17 1.172-.916 4.241h1.215l.915-4.241h-1.215ZM22.35 14.44l.479-2.215h1.848l.222-1.086H23.06l.283-1.36h1.941l.24-1.086h-3.207l-1.215 5.747h1.248Zm-1.206-3.31.197-.931h-1.308l.256-1.18-1.274.281-.796 3.626c-.222 1.027.342 1.591 1.369 1.591.214 0 .573-.042.83-.128l.205-.932a2.997 2.997 0 0 1-.684.102c-.351 0-.6-.12-.513-.547l.402-1.881h1.316Zm-4.635 2.062c0 .342-.419.402-.77.402-.444 0-.94-.12-1.205-.206l-.206.958c.385.094.873.171 1.335.171 1.094 0 1.984-.41 1.984-1.436 0-1.326-1.591-1.095-1.591-1.685 0-.265.257-.36.658-.36.385 0 .924.155 1.104.206l.205-.966a4.645 4.645 0 0 0-1.197-.163c-1.189 0-1.907.53-1.907 1.411 0 1.291 1.59 1.078 1.59 1.668Zm-4.601 1.377c1.343 0 2.25-.975 2.455-2.25.213-1.274-.496-2.25-1.84-2.25-1.342 0-2.248.976-2.454 2.25-.214 1.275.496 2.25 1.839 2.25Zm.112-.984c-.488 0-.873-.385-.694-1.266.18-.88.608-1.265 1.095-1.265.488 0 .873.393.684 1.265-.18.873-.598 1.266-1.085 1.266Zm-5.158-.898h.539c1.72 0 2.677-.846 2.677-2.258 0-1.052-.745-1.736-2.019-1.736H6.47L5.254 14.44h1.232l.376-1.753Zm.214-1.052.402-1.89h.513c.565 0 .838.231.838.77 0 .693-.436 1.12-1.24 1.12h-.513Z",
    })
  );
};
PostFinance24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "24",
  fill: "none",
};
const sizeMap = {
  24: PostFinance24,
};
export function PostFinance(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'PostFinance' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
